// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--townsquare/projects-app-changeboarding';

import { MessageFrontend as createMessageFrontendProjectsAppChangeboardingNonPopups } from '@post-office/browser--townsquare/projects-app-changeboarding-non-popups/placements/in-app-v2/projects-app-changeboarding';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type AppProps } from '@post-office/browser--townsquare/projects-app-changeboarding';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendProjectsAppChangeboardingNonPopups({
		messageTemplateId: 'projects-app-changeboarding-non-popups',
	}),
];

export const RawPlacement: PlacementRendererStage<AppProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<AppProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<AppProps> = RawPlacement;
